import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchClauses: [],
  searchFormDisplayed: true,
  searchResultView: null,
  searchResultPage: { index: 0, size: 10, sort: null },
  globalSearchQuery: '',
  globalSearchResultCleared: false,
  searchResults: null,
  selectedEntityId: -1
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateSearchClauses: (state, action) => {
      state.searchClauses = [...action.payload];
    },
    updateSearchFormDiplayed: (state, action) => {
      state.searchFormDisplayed = action.payload;
    },
    updateSearchResultView: (state, action) => {
      state.searchResultView = action.payload;
    },
    updateSearchResultPage: (state, action) => {
      state.searchResultPage = { ...action.payload };
    },
    updateGlobalSearchQuery: (state, action) => {
      state.globalSearchQuery = action.payload;
    },
    updateGlobalSearchResultCleared: (state, action) => {
      state.globalSearchResultCleared = action.payload;
    },
    updateSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    selectEntity: (state, action) => {
      state.selectedEntityId = action.payload;
    },
    unselectEntity: (state) => {
      state.selectedEntityId = -1;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  updateSearchClauses,
  updateSearchFormDiplayed,
  updateSearchResultView,
  updateSearchResultPage,
  updateGlobalSearchQuery,
  updateGlobalSearchResultCleared,
  updateSearchResults,
  selectEntity,
  unselectEntity
} = searchSlice.actions;

export default searchSlice.reducer;
